var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F7931A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3788 6.22922C12.0634 5.92359 11.552 5.92359 11.2366 6.22922C10.9211 6.53485 10.9211 7.03037 11.2366 7.336L12.3788 6.22922ZM17.1923 12L17.7634 12.5534C18.0789 12.2478 18.0789 11.7522 17.7634 11.4466L17.1923 12ZM11.2366 16.6641C10.9211 16.9697 10.9211 17.4651 11.2366 17.7708C11.552 18.0764 12.0634 18.0764 12.3788 17.7708L11.2366 16.6641ZM11.2366 7.336L16.6212 12.5534L17.7634 11.4466L12.3788 6.22922L11.2366 7.336ZM16.6212 11.4466L11.2366 16.6641L12.3788 17.7708L17.7634 12.5534L16.6212 11.4466Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12H7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRow);
export default __webpack_public_path__ + "static/media/IconRow.999c4721fe95aa6dbfdcd96d0991ada3.svg";
export { ForwardRef as ReactComponent };